import { z } from "zod/v4";

const EnvSchema = z.object({
  VITE_AUTH_BASE_URL: z.string().min(1, "VITE_AUTH_BASE_URL is required"),
  VITE_CONTENT_SERVICE_URL: z
    .string()
    .min(1, "VITE_CONTENT_SERVICE_URL is required"),
  VITE_SOCIAL_SERVICE_URL: z
    .string()
    .min(1, "VITE_SOCIAL_SERVICE_URL is required"),
  VITE_MAPTILER_API_KEY: z.string().min(1, "VITE_MAPTILER_API_KEY is required"),
  VITE_PUBLIC_REVENUE_CAT_API_KEY: z
    .string()
    .min(1, "VITE_PUBLIC_REVENUE_CAT_API_KEY is required"),
  VITE_REVENUECAT_PURCHASE_LINK_URL: z.string().url().optional(),
  FEATURE_FLAG_SHOW_PAYMENTS: z.boolean(),
});

const envVars = {
  VITE_AUTH_BASE_URL: import.meta.env.VITE_AUTH_BASE_URL,
  VITE_CONTENT_SERVICE_URL: import.meta.env.VITE_CONTENT_SERVICE_URL,
  VITE_SOCIAL_SERVICE_URL: import.meta.env.VITE_SOCIAL_SERVICE_URL,
  VITE_MAPTILER_API_KEY: import.meta.env.VITE_MAPTILER_API_KEY,
  VITE_PUBLIC_REVENUE_CAT_API_KEY: import.meta.env
    .VITE_PUBLIC_REVENUE_CAT_API_KEY,
  VITE_REVENUECAT_PURCHASE_LINK_URL: import.meta.env
    .VITE_REVENUECAT_PURCHASE_LINK_URL,
  FEATURE_FLAG_SHOW_PAYMENTS:
    import.meta.env.FEATURE_FLAG_SHOW_PAYMENTS === "true",
};

let config: z.infer<typeof EnvSchema>;
try {
  config = EnvSchema.parse(envVars);
} catch (error) {
  if (error instanceof z.ZodError) {
    console.error(
      "❌ Invalid environment variables for webapp:",
      z.treeifyError(error)
    );
  } else {
    console.error("❌ Error loading configuration:", error);
  }
  const errorMessage =
    "Please ensure VITE_AUTH_BASE_URL, VITE_CONTENT_SERVICE_URL, and VITE_MAPTILER_API_KEY are set in your .env.development file.";
  console.error(errorMessage);
  throw new Error(`Configuration Error: ${errorMessage}`);
}

export default config;
